const FACEBOOK_APP_VERSION = 'v2.11';

function renderFacebookPage(element: HTMLElement) {
  const $ = (window as any).jQuery;
  $.getScript("//connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=" + FACEBOOK_APP_VERSION, () => {
    const fb = (window as any).FB;
    fb.init({
      version   : FACEBOOK_APP_VERSION,
      appId     : process.env.FACEBOOK_APP_ID,
      status    : true,
      cookie    : true,
      xfbml     : true,
    });
    fb.XFBML.parse(element);
  });
}

document.addEventListener('turbolinks:load', () => {

  const element = document.getElementById('fb-page');
  if (element != null) {
    // EXPERIMENT:
    // element.removeAttribute('fb-xfbml-state');
    // element.removeAttribute('fb-iframe-plugin-query');
    renderFacebookPage(element);
  }

});